import { render, staticRenderFns } from "./qDetails.vue?vue&type=template&id=5017ccd7&scoped=true&"
import script from "./qDetails.vue?vue&type=script&lang=js&"
export * from "./qDetails.vue?vue&type=script&lang=js&"
import style0 from "./qDetails.vue?vue&type=style&index=0&id=5017ccd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5017ccd7",
  null
  
)

export default component.exports